import React, { useEffect, useRef, useState } from 'react';
import DataGrid, { Column, FilterRow, HeaderFilter, Pager, Paging, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid'
import { getAllReturnDeduction } from 'pages/Components/API_Modal/ReturnDeductionAPIModal';
import Loader from 'Common/Loader';
import CustomStore from 'devextreme/data/custom_store';
import { Card } from 'react-bootstrap';
import { Result } from 'antd';

const ReturnDeductionMaster: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [permissionDetails, setPermissionDetails] = useState<string[]>([]);
    const dataGridRef = useRef<any>(null);
    const [pagination, setPagination] = useState({ pageSize: 10, pageNumber: 1, });
    const [dataGridFilter, setDataGridFilter] = useState<{
        showFilterRow: boolean;
        showHeaderFilter: boolean;
        currentFilter: 'auto' | 'onClick';
    }>({
        showFilterRow: true,
        showHeaderFilter: true,
        currentFilter: 'auto',
    });

    useEffect(() => {
        const authUserString = localStorage.getItem("authPOSUser");
        if (authUserString) {
            const authUser = JSON.parse(authUserString);
            const permissionData = authUser?.permissions || [];
            setPermissionDetails(permissionData);
        }
    }, []);

    const HasPermission = (permission: string): boolean => {
        return permissionDetails.includes(permission);
    };

    const dataSource = React.useMemo(() => {
        return new CustomStore({
            key: 'id',
            load: async (loadOptions) => {
                try {
                    const params = new URLSearchParams();
                    params.set('skip', String(loadOptions.skip ?? 0));
                    params.set('take', String(loadOptions.take ?? 10 * pagination.pageNumber));
                    params.set('sort', JSON.stringify(loadOptions.sort ?? []));
                    params.set('filter', JSON.stringify(loadOptions.filter ?? null));
                    params.set('searchExpr', JSON.stringify(loadOptions.searchExpr ?? null));
                    params.set('searchOperation', loadOptions.searchOperation ?? '');
                    params.set('searchValue', loadOptions.searchValue ?? '');
                    const response = await getAllReturnDeduction(params);
                    if (!response?.data || response.data.length === 0) {
                        return { data: [], totalCount: 0 };
                    }
                    return response.data.reverse(); // Reverse the data to show the latest entries first
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            },
        });
    }, []);

    const onPagingChange = ({ pageSize, pageIndex, }: { pageSize?: number; pageIndex?: number; }) => {
        setPagination({
            pageSize: pageSize ?? pagination.pageSize,
            pageNumber: (pageIndex ?? pagination.pageNumber - 1) + 1,
        });
    };

    return (
        <React.Fragment>
            {loading && <Loader />}
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Return Deduction Master</h5>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            {HasPermission("ReturnDeduction.Read") ?
                                < DataGrid
                                    ref={dataGridRef}
                                    dataSource={dataSource}
                                    remoteOperations={{ paging: true, filtering: true, sorting: true }}
                                    onOptionChanged={(e) => {
                                        if (e.fullName === 'paging.pageIndex' || e.fullName === 'paging.pageSize') {
                                            onPagingChange({
                                                pageIndex: e.fullName === 'paging.pageIndex' ? e.value : pagination.pageNumber - 1,
                                                pageSize: e.fullName === 'paging.pageSize' ? e.value : pagination.pageSize,
                                            });
                                        }
                                    }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    showBorders={true}
                                >
                                    <Pager
                                        visible={true}
                                        showPageSizeSelector={true}
                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />
                                    <Summary>
                                        <TotalItem
                                            column="Sr.No."
                                            summaryType="count"
                                            displayFormat="Total: {0}"
                                        />
                                    </Summary>
                                    <Paging pageSize={pagination?.pageSize} />
                                    <FilterRow visible={dataGridFilter?.showFilterRow} applyFilter={dataGridFilter?.currentFilter} />
                                    <HeaderFilter visible={dataGridFilter?.showHeaderFilter} />
                                    <SearchPanel visible width={240} placeholder="Search..." />

                                    <Column
                                        caption="Sr.No."
                                        dataType="number"
                                        alignment="center"
                                        width="15%"
                                        cellRender={(e) => {
                                            const rowIndex = e.rowIndex;
                                            const currentPage = pagination.pageNumber;
                                            const pageSize = pagination.pageSize;
                                            const serialNumber = (currentPage - 1) * pageSize + rowIndex + 1;
                                            return <span>{serialNumber}</span>;
                                        }}
                                    />
                                    <Column dataField="materialTypeName" caption="Material Type" dataType="string" />
                                    <Column dataField="typeOfOperation" caption="Type Of Operation" dataType="string" />
                                    <Column dataField="diamondChargePercent" caption="Diamond Charge (%) " dataType="string" width="13%" cssClass="text-center" />
                                    <Column dataField="goldChargePercent" caption="Gold Charge (%) " dataType="string" width="13%" cssClass="text-center" />
                                    <Column dataField="laborChargePercent" caption="Labor Charge (%) " dataType="string" width="13%" cssClass="text-center" />
                                    <Column dataField="otherChargePercent" caption="Other Charge (%) " dataType="string" width="13%" cssClass="text-center" />
                                </DataGrid>
                                :
                                <div className="text-center fs-5 fw-bold">
                                    <Result
                                        status="403"
                                        title="401"
                                        subTitle="Sorry, you are not authorized to access this data."
                                        className="custom-result"
                                    />
                                </div>
                            }
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </React.Fragment >
    )
}

export default ReturnDeductionMaster;

